import React, { useState } from 'react';
import { View, ScrollView } from 'react-native';

import { get as _get } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import PlanAccordion from '../../../CommonUI/PlanAccordion';
import MyUpgradeSelection from '../../Components/MyUpgradeSelection';
import PaymentAndDelivery from '../../Components/PaymentAndDelivery';
import SelectedDeviceCard from '../../Components/SelectedDeviceCard/SelectedDeviceCard';
import TotalCostSection from '../../Components/TotalCostSection';

import styles from './Summary.Styles';

const Summary = ({
  selectedDevice,
  selectedPlan,
  paymentMethods,
  deliveryOptions,
  deliveryAddresses,
  startDate,
  onConfirmPress,
  onTermsAndConditionsPress,
  onReturnPolicyPress,
  isPaymentMethodsLoading,
  isDeliveryAddressesLoading,
  firstBill,
  onEditSelectionPress,
  ...props
}) => {
  const theme = useTheme();
  const [paymentAndDeliveryActiveOptionIndex, setPaymentAndDeliveryActiveOptionIndex] = useState({
    selectedPaymentMehtodIndex: 0,
    selectedDeliveryOptionIndex: 0,
    selectedDeliveryAddressIndex: 0,
  });
  const [isPlanCardExpanded, setIsPlanCardExpanded] = useState(false);
  const { selectedPaymentMehtodIndex, selectedDeliveryOptionIndex, selectedDeliveryAddressIndex } =
    paymentAndDeliveryActiveOptionIndex;

  const selectedPaymentMehtod = _get(paymentMethods, selectedPaymentMehtodIndex);
  const selectedDeliveryOption = _get(deliveryOptions, selectedDeliveryOptionIndex);
  // selectedDeliveryAddressIndex could be -1 incase of pickupstore delivery option then no deliveryAddress
  const selectedDeliveryAddress = _get(deliveryAddresses, selectedDeliveryAddressIndex, null);

  const onPaymentAndDeliveryOptionChange = (stateKey, stateValue) => {
    setPaymentAndDeliveryActiveOptionIndex(state => ({
      ...state,
      [stateKey]: stateValue,
    }));
  };

  return (
    <ScrollView style={styles.containerStyle}>
      <View style={styles.upgradeSelectionPaymentContainer}>
        <View style={styles.upgradeSelectionSectionContainer(theme)}>
          <MyUpgradeSelection onEditSelectionPress={onEditSelectionPress} />
          <SelectedDeviceCard selectedDevice={selectedDevice} />
          <VFText
            style={styles.myPlan(theme)}
            i18nKey={'device_upgrade_summary_step_my_new_plan'}
          />
          <PlanAccordion
            activeSections={isPlanCardExpanded ? [0] : []}
            sections={[{ ...selectedPlan, isRecommended: false, withWhyThisPlan: false }]}
            onChange={() => setIsPlanCardExpanded(!isPlanCardExpanded)}
            withChoosePlan={false}
            freeSubscriptionsKey={'device_upgrade_plan_screen_plan_card_subscriptions_title'}
          />
        </View>
        <PaymentAndDelivery
          paymentMethods={paymentMethods}
          deliveryOptions={deliveryOptions}
          deliveryAddresses={deliveryAddresses}
          selectedPaymentMehtodIndex={selectedPaymentMehtodIndex}
          selectedDeliveryOptionIndex={selectedDeliveryOptionIndex}
          selectedDeliveryAddressIndex={selectedDeliveryAddressIndex}
          selectedDeliveryOption={selectedDeliveryOption}
          onPaymentAndDeliveryOptionChange={onPaymentAndDeliveryOptionChange}
          isPaymentMethodsLoading={isPaymentMethodsLoading}
          isDeliveryAddressesLoading={isDeliveryAddressesLoading}
        />
      </View>
      <TotalCostSection
        selectedDevice={selectedDevice}
        selectedPlan={selectedPlan}
        onTermsAndConditionsPress={onTermsAndConditionsPress}
        onReturnPolicyPress={onReturnPolicyPress}
        onConfirmPress={() => {
          onConfirmPress(selectedPaymentMehtod, selectedDeliveryOption, selectedDeliveryAddress);
        }}
        firstBill={firstBill}
        startDate={startDate}
        containerStyle={styles.totalCostSectionContainer}
      />
    </ScrollView>
  );
};

Summary.propTypes = {
  onConfirmPress: PropTypes.func,
  selectedPlan: PropTypes.object,
  selectedDevice: PropTypes.object,
  paymentMethods: PropTypes.array,
  deliveryOptions: PropTypes.array,
  deliveryAddresses: PropTypes.array,
  firstBill: PropTypes.string,
  isPaymentMethodsLoading: PropTypes.bool,
  isDeliveryAddressesLoading: PropTypes.bool,
  onTermsAndConditionsPress: PropTypes.func,
  onReturnPolicyPress: PropTypes.func,
  startDate: PropTypes.string,
  onEditSelectionPress: PropTypes.func,
};

export default Summary;
